import { Card, CardBody, Col, Container, Row } from "reactstrap";
import InvoiceSixHeader from "./InvoiceSixHeader";
import UserDetails from "./UserDetails";
import InvoiceSixTable from "./InvoiceSixTable";
import { InvoiceButtons } from "../Common/InvoiceButtons";
import { ECommerce, Invoice } from "../../../../../Constants/Constants";
import { Breadcrumbs } from "../../../../../AbstractElements";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";

const InvoiceSixContainer = () => {
  const contentRef = useRef<HTMLDivElement | null>(null);
  const handlePrint = useReactToPrint({ contentRef });
  return (
    <>
      <Breadcrumbs mainTitle={`${Invoice}-6`} parent={ECommerce} />
      <Container>
        <Row>
          <Col sm="12">
          <div ref={contentRef}>
            <Card>
              <CardBody>
                <div className="invoice">
                  <div>
                    <InvoiceSixHeader />
                    <hr />
                    <UserDetails />
                    <InvoiceSixTable />
                  </div>
                </div>
              </CardBody>
            </Card>
            </div>
          </Col>
        </Row>
      </Container>
      <InvoiceButtons handlePrint={handlePrint}/>
    </>
  );
};

export default InvoiceSixContainer;
